import { HireActiveStatus, LocationPreference } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { convertEnumToDisplayText } from '@/utils/tools'

export type HireContractStatusDisplay = {
  text: string
  gray: boolean
  warning: boolean
  subtle: boolean
  error: boolean
  success: boolean
  edited: boolean
}

// @todo Infers the status from the hire; derive it from the contract's own signing fields instead.
export function getHireContractStatus(
  activeStatus: HireActiveStatus | null | undefined,
  pendingContractChanges: boolean | null | undefined,
): HireContractStatusDisplay {
  const base: HireContractStatusDisplay = {
    text: $t('Missing status'),
    gray: false,
    warning: false,
    subtle: false,
    error: false,
    success: false,
    edited: false,
  }

  if (activeStatus === undefined || activeStatus === null) {
    return { ...base, warning: true, subtle: true }
  }

  if (activeStatus === HireActiveStatus.Draft) {
    return { ...base, text: $t('Draft'), gray: true, subtle: true }
  }

  if (activeStatus === HireActiveStatus.Offered) {
    return { ...base, text: $t('Unsigned'), subtle: true, error: true }
  }

  if (pendingContractChanges) {
    return { ...base, text: $t('Pending re-signature'), warning: true, subtle: true, edited: true }
  }

  return { ...base, text: $t('Signed'), subtle: true, success: true }
}

export function locationPreferenceLabel(location: LocationPreference): string {
  switch (location) {
    case LocationPreference.OnsiteOnly:
      return $t('On-site')
    case LocationPreference.RemoteOnly:
      return $t('Remote')
    default:
      return $t(convertEnumToDisplayText(location))
  }
}

export function formatContractRate({
  currency,
  rate,
  rateType,
}: {
  currency?: string | null
  rate?: string | number | null
  rateType?: string | null
}): string {
  return `${currency ?? ''} ${rate ?? ''} / ${rateType?.toLowerCase() ?? ''}`
}
